import { productQuantityBreakPricingStyles } from "@sc/Overrides/Components/ProductQuantityBreakPricing";
import BreakPricing from "@sc/XDL/Icons/BreakPricing";
import { color, createLinkIconStyles, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productQuantityBreakPricingStyles.viewLink = {
    ...createLinkIconStyles(BreakPricing, {
        icon: {
            iconProps: {
                size: 14,
            },
        },
        css: css`
            margin-bottom: 8px;
        `,
    }),
};

productQuantityBreakPricingStyles.modal = {
    cssOverrides: {
        modalBody: css`
            ${xScreen("lte", "md")} {
                max-width: 486px;
                width: 100%;
            }
        `,
    },
    sizeVariant: "small",
};

productQuantityBreakPricingStyles.breakQtyHeader = {};
productQuantityBreakPricingStyles.breakPriceHeader = {};
productQuantityBreakPricingStyles.savingsHeader = {};
productQuantityBreakPricingStyles.breakQtyCell = {};
productQuantityBreakPricingStyles.breakPriceCell = {};
